import commonHelper from '@/app/utility/common.helper.utility';
import TaxTypeDetails from './taxTypeDetails';
export default {
  name: 'TaxType',
  components: {
    TaxTypeDetails
  },
  watch: {
    currentPage: function() {
      this.getTaxTypeList();
    },
    perPage: function() {
      this.currentPage = 1;
      this.getTaxTypeList();
    }
  },
  data() {
    return {
      unsubscribe: null,
      showTaxTypeDetails: false,
      payload: {},
      loader: false,
      editMode: false,
      updateMode: false,
      pageOptions: commonHelper.getPageOption(),
      perPage: commonHelper.perPageRecord,
      currentPage: 1,
      totalRows: null,
      taxType: null,
      data: [],
      fields: [
        {
          key: 'tax_group_id',
          class: 'd-none'
        },
        {
          key: 'tax_group'
        },
        {
          key: 'tax_type'
        },
        {
          key: 'tax_type_id',
          class: 'd-none'
        },
        {
          key: 'active'
        }
      ]
    };
  },
  mounted() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'add') {
          this.showTaxTypeDetails = true;
        }
        if (this.showTaxTypeDetails) {
          setTimeout(() => {
            this.eventBus.$emit('createFormActions', actionName);
          }, 0);
        }
        if (actionName === 'download' && !this.showTaxTypeDetails) {
          this.loader = true;
          /**
           * @param(payload, 'action name', 'file name')
           */
          const downloadpayload = { ...this.payload };
          downloadpayload._limit = this.totalRows;
          this.downloadExcel.downloadData(
            downloadpayload,
            'defineTaxType/getTaxTypeList',
            'Tax-Type',
            () => (this.loader = false)
          );
        }
      }
    });
    this.getTaxTypeList();
  },
  methods: {
    getTaxTypeList() {
      this.payload = {
        tax_type: this.taxType,
        _page: this.currentPage - 1,
        _limit: this.perPage
      };
      this.loader = true;
      this.$store
        .dispatch('defineTaxType/getTaxTypeList', this.payload)
        .then(response => {
          this.loader = false;
          this.data = response.data.data.page;
          this.totalRows = response.data.data.total_elements;
        })
        .catch(() => {
          this.loader = false;
        });
    },
    updateTaxTypeList() {
      this.getTaxTypeList();
    },
    rowSelected(rowData) {
      if (this.$router.currentRoute.name === 'searchtaxType') {
        this.showTaxTypeDetails = true;
        setTimeout(() => {
          this.eventBus.$emit('taxTypeDetails', rowData);
        }, 0);
      } else {
        this.$emit('selectTaxType', rowData);
      }
    },
    clearSearch() {
      this.taxType = null;
    },
    hideTaxTypeDetails() {
      this.showTaxTypeDetails = false;
    }
  },
  beforeDestroy() {
    this.unsubscribe();
  }
};
